import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Language } from '../types/language';

interface FooterProps {
  language: Language;
}

export function Footer({ language }: FooterProps) {
  const translations = {
    subtitle: language === 'fr' 
      ? "Services de rénovation professionnels sur la Côte d'Azur"
      : "Professional home renovation services in the French Riviera",
    menu: {
      title: 'AMG Bâtiment',
      renovation: language === 'fr' ? 'Renovation' : 'Renovation',
      services: 'Services',
      projects: language === 'fr' ? 'Projets' : 'Projects',
      contacts: 'Contacts'
    },
    reviews: language === 'fr'
      ? 'Avis de Nos Clients'
      : 'What Our Clients Say About Us'
  };

  return (
    <footer className="bg-gray-900 text-white mt-16">
      <div className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">
            {translations.reviews}
          </h2>
          <div className="elfsight-app-7764a2f3-5fc2-47e1-9432-0d9319442351" data-elfsight-app-lazy></div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            <a href="https://abatiment.com/" target="_blank" rel="noopener noreferrer" 
               className="block">
              <img 
                src="https://assets.zyrosite.com/dOqyD8v2laFZNJEy/copy_of_copy_of_copy_of_copy_of_fabien_rubio-removebg-preview-AzGeN3oqZ1cepMxz.webp"
                alt="AMG Batiment Logo"
                className="h-16 w-auto"
              />
              <p className="mt-2 text-gray-400">{translations.subtitle}</p>
            </a>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{translations.menu.title}</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://abatiment.com/" className="text-gray-400 hover:text-white transition-colors">
                  {translations.menu.renovation}
                </a>
              </li>
              <li>
                <a href="https://abatiment.com/renovation-services" className="text-gray-400 hover:text-white transition-colors">
                  {translations.menu.services}
                </a>
              </li>
              <li>
                <a href="https://abatiment.com/renovation-projects" className="text-gray-400 hover:text-white transition-colors">
                  {translations.menu.projects}
                </a>
              </li>
              <li>
                <a href="https://abatiment.com/renovation-contacts" className="text-gray-400 hover:text-white transition-colors">
                  {translations.menu.contacts}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-gray-400">
                <Phone className="w-4 h-4" />
                <a href="tel:+33681418107" className="hover:text-white transition-colors">
                  +33 6 81 41 81 07
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Mail className="w-4 h-4" />
                <a href="mailto:projects@abatiment.com" className="hover:text-white transition-colors">
                  projects@abatiment.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <MapPin className="w-4 h-4" />
                <a 
                  href="https://maps.app.goo.gl/eopzR2jfacc4ERZLA" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Marina Baies des Anges Centre d'affaires
                </a>
              </li>
            </ul>
          </div>

          <div>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2925.265565867133!2d7.133376876218748!3d43.634313571102886!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12cdd5253f0f1689%3A0x9eeb762d78af3700!2sR%C3%A9novation%20AMG%20B%C3%A2timent%20-%20Maison%2C%20Villa%2C%20Appartement!5e1!3m2!1sen!2sfr!4v1733249731382!5m2!1sen!2sfr"
              width="100%"
              height="200"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="AMG Batiment Location"
              className="rounded-lg"
            />
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>© {new Date().getFullYear()}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}